var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M1.911 5.798v8.386c0 2.141 1.714 3.876 3.83 3.876h8.383c2.114 0 3.83-1.736 3.83-3.876V5.798c0-2.14-1.715-3.875-3.83-3.875H5.74c-2.113 0-3.829 1.736-3.829 3.875zm-1.822 0C.089 2.64 2.62.078 5.74.078h8.384c3.122 0 5.652 2.56 5.652 5.72v8.386c0 3.16-2.531 5.721-5.652 5.721H5.74c-3.121 0-5.651-2.56-5.651-5.72V5.797zm9.87 9.52c-2.863 0-5.183-2.35-5.183-5.248s2.32-5.247 5.182-5.247c2.862 0 5.183 2.35 5.183 5.247 0 2.898-2.32 5.247-5.183 5.247zm0-1.846c1.855 0 3.359-1.523 3.359-3.402 0-1.878-1.504-3.401-3.36-3.401-1.855 0-3.359 1.523-3.359 3.401 0 1.879 1.504 3.402 3.36 3.402zm5.234-7.515c-.69 0-1.25-.567-1.25-1.266 0-.699.56-1.265 1.25-1.265s1.25.566 1.25 1.265c0 .7-.56 1.266-1.25 1.266z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};
export default SvgInstagram;